import SlimSelect      from 'slim-select';
import autosize from 'autosize';
import MainMenu        from './components/MainMenu.js';
import FontSizeManager from './components/FontSizeManager.js';
import Accordion       from './components/According.js';
import showHideBox     from './utils/show-hide-box.js';
import initPasswordToggle from './utils/initPasswordToggle.js';

window.slimSelectContestInstances = {};
window.slimSelectInstances = {};
window.autosizeTextareas = function () {
	autosize(document.querySelectorAll('textarea:not(.is-static)'));
};
/**
 * Init or reinit SlimSelect on elements with attribute data-select-contest.
 *
 * If SlimSelect instance for the element already exists, it will be destroyed and recreated.
 *
 * @function initSlimSelectContest
 * @since 1.1.0
 *
 * @example
 * // Init SlimSelect on page load
 * window.addEventListener('DOMContentLoaded', window.initSlimSelectContest);
 *
 * @example
 * // Init SlimSelect after load new content via AJAX
 * window.initSlimSelectContest();
 */
window.initSlimSelectContest = function () {
	const contestStyle = document.querySelectorAll('[data-select-contest]');
	
	contestStyle.forEach((el) => {
		const selectId = el.id || el.name;
	
		// Create new instance of SlimSelect
		window.slimSelectContestInstances[selectId] = new SlimSelect({
			select   : el,
			settings : {
				placeholderText : '',
				showSearch      : false,
				focusSearch     : false,
				allowDeselect   : true,
			},
			events : {
				afterChange : () => {
					el.dispatchEvent(new Event('blur', { bubbles : true }));
				},
			},
		});
	});
};

window.SlimSelect = SlimSelect;
window.createSlimSelect = function (element, options) {
	const el = typeof element === 'string' ? document.querySelector(element) : element;
	
	if (!el) {
		return null;
	}
	
	const defaultOptions = {
		settings : {
			placeholderText   : '',
			showSearch        : true,
			searchPlaceholder : 'Поиск...',
			allowDeselect     : true,
		},
		events : {
			afterChange : () => {
				el.dispatchEvent(new Event('blur', { bubbles : true }));
			},
		},
	};
	
	const mergedOptions = { ...defaultOptions, ...options };
	
	return new SlimSelect({
		select : el,
		...mergedOptions,
	});
};

// Init
function init() {
	const mainMenu = new MainMenu();
	mainMenu.init();
	
	const lkMenu = new MainMenu({
		container : '[data-lk-menu="wrapper"]',
		trigger   : '[data-lk-menu="trigger"]',
		close     : '[data-lk-menu="close"]',
		bodyClass : 'is-lk-menu-open',
	});
	lkMenu.init();
	
	const fontSizeWrapper = document.querySelectorAll('[data-font-size="wrapper"]');
	fontSizeWrapper.forEach((el) => {
		const fontSizeManager = new FontSizeManager(el);
		fontSizeManager.init();
	});
	
	const selectStyle = document.querySelectorAll('[data-select-style]');
	selectStyle.forEach((el) => {
		const hasNoSelect = el.hasAttribute('data-no-search');
		
		// eslint-disable-next-line no-new
		new SlimSelect({
			select   : el,
			settings : {
				placeholderText   : '',
				showSearch        : !hasNoSelect,
				focusSearch       : false,
				searchPlaceholder : 'Поиск...',
				searchHighlight   : !hasNoSelect,
				allowDeselect     : true,
			},
			events : {
				afterChange : () => {
					el.dispatchEvent(new Event('blur', { bubbles : true }));
				},
			},
		});
	});
	
	const showHideBoxWrapper = document.querySelectorAll('[data-show-hide="wrapper"]');
	showHideBoxWrapper.forEach((el) => {
		showHideBox(el);
	});
	
	const accordionWrapper = document.querySelectorAll('[data-according="wrapper"]');
	accordionWrapper.forEach((el) => {
		const accordion = new Accordion(el);
		accordion.init();
	});
	
	const toogleActiveButtons = document.querySelectorAll('[data-toggle-active]');
	toogleActiveButtons.forEach((el) => {
		el.addEventListener('click', (e) => {
			const target = e.target.closest('[data-toggle-active]');
			const activeClass = target.dataset.toggleActive;
			target.classList.toggle(activeClass);
		});
	});
	const tooglePanelButtons = document.querySelectorAll('[data-toggle-panel]');
	tooglePanelButtons.forEach((el) => {
		el.addEventListener('click', (e) => {
			const element = e.target.closest('[data-toggle-panel]');
			const target = document.querySelector(element.dataset.togglePanel);
			if (!target)  return;
			
			element.classList.toggle('active');
			target.classList.toggle('is-active');
		});
	});
	
	const showHidePasswordWrapper = document.querySelectorAll('[data-input-password]');
	showHidePasswordWrapper.forEach((el) => {
		initPasswordToggle(el);
	});
	
	window.initSlimSelectContest();
	window.autosizeTextareas();
}

document.addEventListener('DOMContentLoaded', () => init());
